import { Slider, LinearProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { COLORS } from '../../../constants/colors'

const StyledSlider = withStyles({
  root: {
    color: '#52af77',
    height: 12,
    marginTop: 10,
  },
  thumb: {
    height: '42px',
    width: '42px',
    border: '4px solid #FFFFFF',
    borderRadius: '21px',
    backgroundColor: '#5CBBDB',
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  track: {
    margin: '5px 6px',
    height: '18px',
    borderRadius: '9px',
    backgroundColor: 'rgba(55,111,139,0.2)',
  },
  rail: {
    boxSizing: 'border-box',
    height: '28px',
    border: '1px solid rgba(26,25,25,0.2)',
    borderRadius: '14px',
    backgroundColor: 'white',
  },
  markLabel: {
    marginTop: '26px',
    height: '18.2px',
    width: '25px',
    color: '#1A1919',
    fontFamily: 'Nunito Sans',
    fontSize: '13px',
    lineHeight: '18px',
    '&:first-child': {
      marginLeft: '10px',
    },
    '&:last-child': {
      marginRight: '10px',
    },
  },
})(Slider)

const StyledLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: 'rgba(26,25,25,0.2)',
  },
  barColorPrimary: {
    backgroundColor: `${COLORS.THEME.SECONDARY}`,
  },
})(LinearProgress)

export { StyledSlider, StyledLinearProgress }
